import { AxiosResponse } from 'axios'

export const majorVersionFromResponse = (response: AxiosResponse): number => {
  return majorVersion(response.headers['x-api-version'])
}

export const majorVersion = (version: string): number => {
  return Number(version.split('.')[0])
}
